<template lang="pug">
  div
    label.design-guide.warning
      p {{ $t('help.guides.body') }}
        ul
          li
            a(:href="$t('help.guides.design.url')" target='_blank') {{ $t('help.guides.design') }}
    card.quote-upload-card
      input(
        type='file',
        name='quoteItemUpload',
        multiple,
        ref='quoteItemUpload'
        @change='filesChange($event.target, $event.target.files)'
      )
      span {{ $t('quote.instructions') }}
</template>

<script>
import card from '@/components/common/card.vue'

export default {
  components: { card },
  data: () => ({}),
  methods: {
    resetFileUpload () { this.$refs.quoteItemUpload.value = '' },
    filesChange (input, files) {
      // Filter type of files
      //
      // files = Object.values(files).filter(file => {
      //   if ([
      //     'application/zip',
      //     'application/x-rar-compressed',
      //     'application/STEP',
      //     'application/sla',
      //     'application/iges',
      //     'application/OBJ',
      //   ].indexOf(file.type) > -1) {
      //     return true
      //   }

      //   this.$notify({
      //     group: 'general',
      //     type: 'error',
      //     title: 'Wrong file type',
      //     text: $t('quote.wrongFileType', [file.name]),
      //     duration: -1
      //   })
      // })

      for (const file of files) {
        this.$store.dispatch('quote/createItem', {
          file
        })
      }
      this.resetFileUpload()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/abstract/variables.scss";

  .design-guide {
    background: #fff;
    color: $dark-gray;
    padding: 2em;
    margin-bottom: 2em;
    line-height: normal;
    display: flex;

    p {
      padding-left: 5em;

      @media only screen and (max-width: $mobile) {
        padding-left: 0;
      }
    }

    @media only screen and (max-width: $mobile) {
      &.warning:before {
        display: none !important;
      }
    }

    .col {
      padding: 0 1em;

      &:nth-child(1) {
        flex: 0.3;
      }
      &:nth-child(2) {
        flex: 11;
      }
    }

    li {
      color: $blue;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-top: 0.5em;
    }
  }

  .quote-upload-card {
    padding: 2em 3em;
    display: flex;
    align-items: center;

    @media only screen and (max-width: $mobile) {
      padding: 2em;
      display: block;
    }

    span {
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
      color: $blue;
      width: 70%;
      margin-left: 3em;

      @media only screen and (max-width: $mobile) {
        margin-left: 0;
      }
    }
  }

  input[type=file] {
    color: transparent;
    display: inline;
    margin: 0 auto;
    background: none;

    @media only screen and (max-width: $mobile) {
      display: block;
      width: 100%;
    }
  }

  input[type=file]::-webkit-file-upload-button {
    color: $dark-gray;
    background-color: #fff;
    border: 2px solid $dark-gray;
    width: auto;
    padding: 1em 2em;
    margin: 10px 0;
    transition: 250ms color, 250ms background;
    border-radius: 30em;
    cursor: pointer;

    &:hover {
      color: #fff;
      background-color: $dark-gray;
    }
  }

</style>
